/* eslint-disable no-unused-vars */
import { useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { Routes, Route, useLocation } from 'react-router-dom';

// Analytics
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';
import ReactGA from 'react-ga4';

// Components
import { Footer, ResetPassword, LoginAndSignup } from './Components';

// Pages
import {
  Profile,
  Home,
  NotesPreview,
  Notes,
  Dashboard,
  Test,
  Verify,
  QpPreview,
  Blog,
  UploadBlog,
  BlogPreview,
  Projects,
  AddProject,
  ProjectDashboard,
  Admin,
  CourseStr,
  CourseStrPreview,
  QuestionPapersContainer,
  Career,
  Alumni,
  AboutUs,
} from './Pages';

import { ProtectRoute, capitalizeFirstLetter } from './Helpers';

if (document.location.hostname !== 'localhost') {
  ReactGA.initialize(process.env.REACT_APP_TRACKING_ID);
  console.log('Init Analytics');
}

function App() {
  const location = useLocation();

  useEffect(() => {
    const pageName = location.pathname.split('/')[1];
    const path = pageName ? pageName + ' - Vidkarya' : 'Vidkarya';
    document.title = capitalizeFirstLetter(path);
  }, [location]);

  return (
    <>
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route exact path="/about" element={<AboutUs />} />

        <Route
          exact
          path="/career"
          element={
            <ProtectRoute>
              <Career />
            </ProtectRoute>
          }
        />

        <Route
          exact
          path="/admin321"
          element={
            <ProtectRoute>
              {' '}
              <Admin />{' '}
            </ProtectRoute>
          }
        />
        <Route
          exact
          path="/profile/:action"
          element={
            <ProtectRoute>
              {' '}
              <Profile />{' '}
            </ProtectRoute>
          }
        />

        <Route exact path="/auth" element={<LoginAndSignup />} />
        <Route exact path="/reset/password/:userid/:token" element={<ResetPassword />} />
        <Route exact path="/verify/:userid/:token" element={<Verify />} />

        <Route
          exact
          path="/dashboard"
          element={
            <ProtectRoute>
              {' '}
              <Dashboard />{' '}
            </ProtectRoute>
          }
        />

        <Route exact path="/projects" element={<Projects />} />
        <Route
          exact
          path="/projects/dashboard"
          element={
            <ProtectRoute>
              {' '}
              <ProjectDashboard />{' '}
            </ProtectRoute>
          }
        />
        <Route
          exact
          path="/projects/add"
          element={
            <ProtectRoute>
              {' '}
              <AddProject />{' '}
            </ProtectRoute>
          }
        />

        <Route exact path="/notes" element={<Notes />} />
        <Route
          exact
          path="/notes/preview/:id"
          element={
            <ProtectRoute>
              {' '}
              <NotesPreview />{' '}
            </ProtectRoute>
          }
        />

        <Route exact path="/blogs" element={<Blog />} />
        <Route exact path="/blogs/:blogid" element={<BlogPreview />} />
        <Route
          exact
          path="/blogs/create"
          element={
            <ProtectRoute>
              {' '}
              <UploadBlog />{' '}
            </ProtectRoute>
          }
        />

        <Route exact path="/courseStr" element={<CourseStr />} />
        <Route
          exact
          path="/courseStr/:courseId"
          element={
            <ProtectRoute>
              {' '}
              <CourseStrPreview />{' '}
            </ProtectRoute>
          }
        />

        <Route exact path="/test" element={<Test />} />
        <Route
          exact
          path="/qp/preview/:id"
          element={
            <ProtectRoute>
              {' '}
              <QpPreview />{' '}
            </ProtectRoute>
          }
        />
        <Route exact path="/question-papers" element={<QuestionPapersContainer />} />

        <Route exact path="/alumni" element={<Alumni />} />
      </Routes>
      <Analytics />
      <SpeedInsights />
      <ToastContainer position="top-center" limit={3} />
      <Footer />
    </>
  );
}

export default App;
